// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--ZQtQV","text":"_93444fe79c--text--vTPjO"};